import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { MissingRole as MissingRoleComponent } from '@smorder/core';
import { RoleNames } from '@smorder/logic';

import { NavigationLink } from '../../components';
import config from '../../../run-config';

const styles = theme => ({
  link: {
    marginTop: 10,
    color: theme.palette.link.main,
  },
});

const MissingRole = ({ classes, roles }) => {
  const hasCustomerRole = roles.includes(RoleNames.Customer) || roles.includes(RoleNames.CampaignManager);

  return (
    <MissingRoleComponent logo={config.loginLogo}>
      {hasCustomerRole ? (
        <NavigationLink external to={`${config.apiHost}/admin`}>
          <div className={classes.link}>Zurück zur Admin-UI</div>
        </NavigationLink>
      ) : (
        <NavigationLink to="/login">
          <div className={classes.link}>Zum Login</div>
        </NavigationLink>
      )}
    </MissingRoleComponent>
  );
};


MissingRole.propTypes = {
  classes: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired,
};

export default withStyles(styles)(MissingRole);
